import CreateClient from "./CreateClient";
import DisplayClient from "./DisplayClient";
import { Route } from "react-router-dom";

const routes = {
  key: "CLIENT",
  routes: ({ userScope }) => [
    <Route path={`${userScope}/client`} key="client">
      <Route
        path="creation"
        key={"client-creation"}
        element={<CreateClient />}
      />
      <Route key={"client-display"} path=":slug" element={<DisplayClient />} />
    </Route>,
  ],
};
export default routes;
